/**
 * SEO Checker App Configuration
 */

export const config = {
  /**
   * Homepage URL - where users are redirected to request a new report
   */
  homepageUrl: '/seo-checker/',
};

export default config;

